import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { pollResultsActions } from './pollResultsSagas'
import { selectPollResultsState } from './pollResultsSelectors'

const usePollResults = () => {
  const { t } = useTranslation('devToolsNew')
  const dispatch = useDispatch()
  const { polls, isLoading, error, expandedKeys } = useSelector(selectPollResultsState)

  useEffect(() => {
    dispatch({ type: pollResultsActions.FETCH })
  }, [dispatch])

  return {
    title: t('communication_board.poll_results.title'),
    intro: t('communication_board.poll_results.intro'),
    loadingText: t('communication_board.poll_results.loading'),
    emptyText: t('communication_board.poll_results.empty'),
    error: error ?? '',
    loaderHidden: !isLoading,
    errorHidden: !error,
    emptyHidden: isLoading || !!error || polls.length > 0,
    cards: polls.map(poll => ({ poll, expanded: expandedKeys.includes(poll.poll_key) })),
  }
}

export default usePollResults
